import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.CardsSlice} CardsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<CardsSlice>} CardsProps
 * @type {import("react").FC<CardsProps>}
 */
const Cards = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="contre-uno bg-terracota-400 rounded-t-4xl lg:rounded-t-[3.7rem] -mt-14"
    >
      <div className="padding-y flex flex-col gap-10 lg:gap-18 padding-x">
        {isFilled.richText(slice.primary.title) && (
          <div className="flex flex-col gap-4">
          <PrismicRichText
            field={slice.primary.title}
            components={{
              heading2: ({ children }) => <h2 className="h4-h2 md:text-center text-terracota-100">{children}</h2>,
              heading3: ({ children }) => <h3 className="h4-h2 md:text-center text-terracota-100">{children}</h3>,
              paragraph: ({ children }) => <p className="body-m md:text-center text-terracota-100">{children}</p>,
            }}
          />
          </div>
        )}
        <div className="flex flex-col md:flex-row gap-8 md:gap-4 lg:gap-6 justify-center items-stretch">
          {Array.isArray(slice.primary.cards) &&
            slice.primary.cards.map((card, index) => (
              <div key={`card-${index}`} className="flex flex-col md:w-1/3 lg:max-w-80 bg-white items-center py-6 gap-7 px-4 rounded-t-[7.5rem] rounded-b-lg border-6 border-terracota-300">
                {isFilled.image(card.picto) && (
                  <PrismicImage className="w-25 h-25 object-contain"
                    field={{
                      ...card.picto,
                      alt: card.picto.alt || "Image d'illustration",
                    }}
                  />
                )}
                <div className="w-full text-bleu-950">
                  {isFilled.keyText(card.title) && <h3 className="h4 p-2.5">{card.title}</h3>}

                  {isFilled.richText(card.infos) && (
                    <PrismicRichText
                      field={card.infos}
                      components={{
                        paragraph: ({ children }) => <p className="body-xs p-2.5">{children}</p>,
                        list: ({ children }) => <ul className="puce-checklist" >{children}</ul>,
                        listItem: ({ children }) => <li className="body-xs py-2.5">{children}</li>,
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Cards;
